import React, { useState } from 'react';
import { Box, Button, Card, CardContent, Grid, Switch, TextField, Typography, FormControlLabel, Chip, Stack } from '@mui/material';

const Notifications = () => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [segment, setSegment] = useState('all');
  const [schedule, setSchedule] = useState('now');
  const [enabled, setEnabled] = useState(true);

  const handleSend = (e) => {
    e.preventDefault();
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>Manage Push Notifications</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>Create Notification</Typography>
              <Box component="form" onSubmit={handleSend}>
                <TextField label="Title" fullWidth sx={{ my: 1 }} value={title} onChange={(e) => setTitle(e.target.value)} />
                <TextField label="Message" fullWidth multiline rows={3} sx={{ my: 1 }} value={message} onChange={(e) => setMessage(e.target.value)} />
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField label="Segment" fullWidth value={segment} onChange={(e) => setSegment(e.target.value)} placeholder="all, premium, inactive-7d" />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField label="Schedule" fullWidth value={schedule} onChange={(e) => setSchedule(e.target.value)} placeholder="now or ISO datetime" />
                  </Grid>
                </Grid>
                <FormControlLabel control={<Switch checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />} label="Enabled" sx={{ mt: 1 }} />
                <Button type="submit" variant="contained" sx={{ mt: 2 }}>Send</Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>Recent Campaigns</Typography>
              <Stack spacing={1}>
                <Chip label="Hydration Tip - All" />
                <Chip label="Cycle Reminder - Premium" color="primary" />
                <Chip label="We miss you! - Inactive" color="secondary" />
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Notifications;
